import { ActionContext, Module } from 'vuex';

export type NotificationType = 'success' | 'error' | 'info' | 'warning';

interface NotificationState {
  show: boolean;
  message: string;
  type: NotificationType;
}

export interface NotificationPayload {
  message: string;
  type?: NotificationType;
  timeout?: number;
}

export const notifications: Module<NotificationState, any> = {
  namespaced: true,

  state: (): NotificationState => ({
    show: false,
    message: '',
    type: 'success',
  }),

  actions: {
    triggerToast({ commit }: ActionContext<NotificationState, any>, payload: NotificationPayload) {
      commit('SET_NOTIFICATION', {
        message: payload.message,
        type: payload.type || 'success',
      });

      setTimeout(() => {
        commit('CLEAR_NOTIFICATION');
      }, payload.timeout || 3000);
    },
  },

  mutations: {
    SET_NOTIFICATION(state, { message, type }) {
      state.show = true;
      state.message = message;
      state.type = type;
    },
    CLEAR_NOTIFICATION(state) {
      state.show = false;
    },
  },
};
